export default "__VITE_ASSET__C7DUDJkA__"